import React from "react";
import "./spinner.css";

const Spinner = () => {
  return (
    <div className="center">
      <i className="fa fa-spinner fa-pulse fa-2x fa-fw" />
    </div>
  );
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/common/spinner/spinner.jsx